import React, { useEffect, useState } from "react";
import { useRuleResourceContext } from "../../contexts/RuleResourceContext";

interface Props {
  sqlQry: string;
  error?: any;
  setErrors: React.Dispatch<React.SetStateAction<any>>;
  setInputRef?: (key: string) => (el: HTMLInputElement | null) => void;
}

const FinalQueryResult: React.FC<Props> = (_props) => {
  // Use a regular expression to find variables wrapped with $$
  const {
    globalVariables,
    tempGlobalVariables,
    setTempGlobalVariables,
    queryBuilderTempValue,
  } = useRuleResourceContext();

  const [variables, setVariables] = useState<any>([]);

  useEffect(() => {
    const queryVariables = (
      (queryBuilderTempValue &&
        queryBuilderTempValue?.match(/\$\$(.*?)\$\$/g)) ||
      []
    ).map((match: any) => match.slice(2, -2).toLowerCase());

    const getUniqueValues = (arr: any) => {
      return arr.filter((v: any, i: any, a: any) => a.indexOf(v) === i);
    };
    setVariables(getUniqueValues(queryVariables) ?? []);
  }, [queryBuilderTempValue]);

  useEffect(() => {
    if (variables?.length > 0 && globalVariables) {
      const globalVars: any = {};
      variables.forEach((variable: any) => {
        if (tempGlobalVariables[variable] !== undefined) {
          globalVars[variable] = tempGlobalVariables[variable];
        } else if (globalVariables[variable] !== undefined) {
          globalVars[variable] = globalVariables[variable];
        } else {
          globalVars[variable] = "";
        }
      });
      // Compare the current tempLocalVariables with the new ones to avoid unnecessary updates
      if (JSON.stringify(tempGlobalVariables) !== JSON.stringify(globalVars)) {
        // setTempLocalVariables(globalVars);
        setTempGlobalVariables(globalVars);
      }
    } else {
      setTempGlobalVariables({});
    }
  }, [variables]);

  // Renders nothing — this component exists solely to run the two
  // useEffects above, which parse $$variable$$ placeholders from the
  // active query and keep tempGlobalVariables in sync for save/validation.
  // The used-variable chip display has been removed; variables are now
  // managed exclusively through the AvailableVariables section.
  return null;
};

export default React.memo(FinalQueryResult);
